import React, { useRef } from "react";
import { Form } from "react-bootstrap";

const FileUploadInput = ({ label, name, required = false, formik }) => {
  const fileInputRef = useRef(null);
  const file = formik.values[name];

  const handleFileChange = (e) => {
    const selectedFile = e.currentTarget.files[0];
    formik.setFieldValue(name, selectedFile);
  };

  const handleRemove = () => {
    formik.setFieldValue(name, null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const triggerFileDialog = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // programmatically trigger input
    }
  };

  return (
    <div className="mb-4">
      <Form.Label>{label}</Form.Label> {required && <span className="text-danger">*</span>}

      <div className="position-relative">
        <div
          className="d-flex align-items-center border rounded px-3 py-2"
          style={{
            height: "40px",
            backgroundColor: "#f9f9f9",
            borderColor: "#ced4da",
            position: "relative",
            zIndex: 1,
          }}
        >
          {/* Hidden File Input */}
          <Form.Control
            type="file"
            name={name}
            onChange={handleFileChange}
            onBlur={formik.handleBlur}
            isInvalid={!!formik.errors[name] && formik.touched[name]}
            style={{ display: "none" }}
            ref={fileInputRef}
          />

          {/* File name or placeholder */}
          {/* <span
            className="flex-grow-1 text-muted"
            style={{ fontSize: "13px", cursor: "pointer" }}
            onClick={triggerFileDialog}
          >
            {file ? file.name : "Upload Doc"}
          </span> */}

          <span
            className="flex-grow-1 text-muted text-truncate"
            style={{
              fontSize: "13px",
              cursor: "pointer",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            onClick={triggerFileDialog}
            title={file ? file.name : "Upload Doc"} // show full name on hover
          >
            {file ? file.name : "Upload Doc"}
          </span>


          {/* Icon */}
          {file ? (
            <span
              fontSize="small"
              style={{
                cursor: "pointer",
                marginLeft: "10px",
                zIndex: 2,
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleRemove();
              }}
            >
              <i className="bi bi-x-lg"></i>
            </span>
          ) : (
            <span
              fontSize="small"
              style={{ cursor: "pointer", zIndex: 2 }}
              onClick={(e) => {
                e.stopPropagation();
                triggerFileDialog();
              }}
            >
              <i className="bi bi-upload"></i>
            </span>
          )}
        </div>

        <Form.Control.Feedback type="invalid" style={{ display: (required ? 'block' : 'none') }}>
          {formik.errors[name]}
        </Form.Control.Feedback>
      </div>
    </div>
  );
};

export default FileUploadInput;
